/**
 * Ops health (A.4) — delivery-pipeline status surfaced to the supervisor.
 */
import { z } from 'zod';
export const OpsHealthSchema = z.object({
    outbox_pending: z.number().int(),
    outbox_failed: z.number().int(),
    notifications_failed: z.number().int(),
    notifications_queued: z.number().int(),
});
export const OpsRetryResponseSchema = z.object({
    retried: z.number().int(),
});
//# sourceMappingURL=ops.js.map